import * as CurrencyFormatter from '@Components/Utilities/CurrencyFormatter';

const setupAuctionTimeBiddingSignalRHub = (hubUrl, isEmployee, eventIds, updateBiddingData, updateBiddingPausedStatus) => {
    let transportMethods = ['webSockets', 'longPolling'];

    let connection = $.connection;
    connection.hub.logging = isEmployee;
    connection.hub.url = hubUrl;

    let hubProxy = connection.auctiontimebidding;

    if (hubProxy == null || hubProxy == undefined) {
        console.log("SignalR connection failed: No hub was provided");
        return false;
    }

    hubProxy.client.jsUpdateMessage = (Event_Pub, CurrentBid, NextBid, NumberOfBids, SecondsRemaining, OpeningBid, HighBidderTUID, sEndDate, SentTime) => {
        // Parse this into the object we'd expect back from the AuctionUpdate API for consistent data handling on the consuming side
        updateBiddingData([{
            EventIDPub: Event_Pub,
            EventID: parseInt(Event_Pub.split("-")[0]),
            NumberOfBids: NumberOfBids,
            CurrentBid: CurrentBid,
            NextBid: NextBid,
            SecondsRemaining: SecondsRemaining,
            OpeningBid: OpeningBid,
            HighBidderLowerPubTUID: HighBidderTUID,
        }], null);
    };

    hubProxy.client.jsBiddingPaused = function (biddingPaused) {
        updateBiddingPausedStatus(biddingPaused)
    }

    connection.hub.start({ jsonp: true, transport: transportMethods }).done(function () {
        hubProxy.server.addToGroups(eventIds, true);
        if (connection.hub.logging == true) { console.log("Connection succeeded"); }
    }).fail(function (e) {
        console.log("SignalR connection failed: " + e);
    });

    connection.hub.disconnected(function () {
        if (connection.hub.logging === true) { console.log("Failed to reconnect"); }
        setTimeout(function () {
            connection.hub.start({ jsonp: true, transport: transportMethods }).done(function () {
                hubProxy.server.addToGroups(eventIds, true);
                if (connection.hub.logging == true) { console.log("Connection succeeded"); }
            }).fail(function (e) {
                console.log("SignalR connection failed: " + e);
            });
        }, 3000); // attempt to restart connection after 3 seconds.
    });

    connection.hub.reconnecting(function () {
        if (connection.hub.logging === true) { console.log("Attemptting to reconnect"); }
    });

    connection.hub.reconnected(function () {
        if (connection.hub.logging === true) { console.log("Attempt to reconnect has succeeded"); }
    });

    return connection;
};

// This takes our existing AuctionTimeInfo : AuctionInfo object and patches in the updates from either SignalR or the AuctionUpdates API
const patchInUpdatedAuctionData = (currentAuctionBiddingData, auctionUpdateData, biddingInputPaused) => {
    // copy the object just so we're not touching the original
    const updatedData = { ...currentAuctionBiddingData };

    // SignalR does not include the overarching bidding paused status. That comes from a separate push on that end
    // AuctionsUpdate API will return both the data and the overaching bidding paused status
    if (biddingInputPaused != null) {
        updatedData.IsAllBiddingPaused = biddingInputPaused;
    }

    if (auctionUpdateData) {
        // Patch in the updated data
        updatedData.NumberOfBids = auctionUpdateData.NumberOfBids;
        updatedData.CurrentBid = auctionUpdateData.CurrentBid;
        updatedData.CurrentBidFormatted = `${updatedData.CurrencyCode?.toUpperCase()} ${CurrencyFormatter.FormatCurrency(auctionUpdateData.CurrentBid, updatedData.CultureCode, updatedData.CurrencyCode, 0, 0)}`
        updatedData.NextBidAmount = `${updatedData.CurrencyCode?.toUpperCase()} ${CurrencyFormatter.FormatCurrency(auctionUpdateData.NextBid, updatedData.CultureCode, updatedData.CurrencyCode, 0, 0)}`

        if (auctionUpdateData.SecondsRemaining >= 0) {
            updatedData.TimeLeft = auctionUpdateData.SecondsRemaining;
        }
        else {
            updatedData.TimeLeft = translator.translate('sandhills.tradepubwebsite.mvc.auctionhasended');
        }
        updatedData.TimeRemaining = auctionUpdateData.SecondsRemaining * 1000; // Convert to milliseconds
        // SignalR does not push the individual listing bidding paused status either
        if (auctionUpdateData.ListingIsPaused != null) {
            updatedData.IsListingPaused = auctionUpdateData.ListingIsPaused;
        }

        // See if we need to change any banners based on the new information
        if (updatedData.UserBidInfo && updatedData.UserBidInfo.UsersLastBid > 0 && auctionUpdateData.HighBidderLowerPubTUID) {
            if (updatedData.BiddingUserID == parseInt(auctionUpdateData.HighBidderLowerPubTUID)) {
                updatedData.UserBidInfo = { ...updatedData.UserBidInfo, UserIsOutBid: false, UserIsTieBidder: false, ListingBidStatusText: translator.translate('sandhills.tradepubwebsite.mvc.highbidder') };
            }
            else if (updatedData.UserBidInfo.UsersLastBid == auctionUpdateData.CurrentBid) {
                updatedData.UserBidInfo = { ...updatedData.UserBidInfo, UserIsOutBid: false, UserIsTieBidder: true, ListingBidStatusText: translator.translate('sandhills.tiebidder') };
            }
            else {
                updatedData.UserBidInfo = { ...updatedData.UserBidInfo, UserIsOutBid: true, UserIsTieBidder: false, ListingBidStatusText: translator.translate('sandhills.tradepubwebsite.mvc.outbidtext') };
            }
        }
    }

    return updatedData;
};

export {
    setupAuctionTimeBiddingSignalRHub,
    patchInUpdatedAuctionData
};